import { render } from "./EntityPage.vue?vue&type=template&id=b24fd380"
import script from "./EntityPage.vue?vue&type=script&lang=js"
export * from "./EntityPage.vue?vue&type=script&lang=js"
script.render = render

export default script